import { useState, type Dispatch, type SetStateAction } from 'react';
import { ModalStyled } from 'src/components/common/ModalStyled';
import { useGetFeedback } from 'src/hooks';
import type { TReviewFormState } from 'src/types';
import {
  FeedbackModalHappy,
  FeedbackModalReviewCTA,
  FeedbackModalSad,
  FeedbackModalThanks,
} from './FeedbackModalBlocks';

type Props = {
  cartId: string;
  open: boolean;
  onClose: () => void;
};

export const FeedbackModal = ({ cartId, open, onClose }: Props) => {
  const [reviewFormState, setReviewFormState] = useState<TReviewFormState>(undefined);
  const { hideReviewCTA } = useGetFeedback();

  const handleSetReviewFormState: Dispatch<SetStateAction<TReviewFormState>> = (value) => {
    const next = typeof value === 'function' ? value(reviewFormState) : value;
    setReviewFormState(next);
  };

  const handleClose = (_xButtonClose?: boolean) => {
    if (!reviewFormState) {
      hideReviewCTA('dismissed');
    }
    onClose();
    // Wait for the modal close animation before resetting state
    setTimeout(() => setReviewFormState(undefined), 150);
  };

  return (
    <ModalStyled open={open} onClose={handleClose} closeOnOutsideClick={false} customMaxWidth={400}>
      <div className='flex flex-col items-center justify-center gap-6 overflow-x-hidden p-8'>
        {!reviewFormState && (
          <FeedbackModalReviewCTA setReviewFormState={handleSetReviewFormState} />
        )}
        {reviewFormState === 'happy' && (
          <FeedbackModalHappy setReviewFormState={handleSetReviewFormState} cartId={cartId} />
        )}
        {reviewFormState === 'sad' && (
          <FeedbackModalSad setReviewFormState={handleSetReviewFormState} cartId={cartId} />
        )}
        {reviewFormState === 'thanks' && <FeedbackModalThanks onClose={handleClose} />}
        {reviewFormState === 'thanks-download' && (
          <FeedbackModalThanks onClose={handleClose} isDownload />
        )}
      </div>
    </ModalStyled>
  );
};
